module.exports = __webpack_public_path__ + "img/132w.3c31732.jpg";